import React from 'react';
import PropTypes from 'prop-types';

import GlobalStyle from './GlobalStyle';
import StickyHeaderWrapper from './StickyHeaderWrapper';
import SiteHeader from './SiteHeader';
import SiteBottom from './SiteBottom';

const Layout = ({ children, selectedLocale, location, hasHero }) => (
  <>
    <GlobalStyle />

    <StickyHeaderWrapper
      selectedLocale={selectedLocale}
      location={location}
      hasPadding
    >
      {(isSticky) => (
        <SiteHeader
          location={location}
          selectedLocale={selectedLocale}
          isSticky={isSticky || !hasHero}
        />
      )}
    </StickyHeaderWrapper>

    <main style={{ flex: 1 }}>{children}</main>

    <SiteBottom selectedLocale={selectedLocale} />
  </>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  selectedLocale: PropTypes.string.isRequired,
  location: PropTypes.shape({}).isRequired,
  hasHero: PropTypes.bool.isRequired,
};

export default Layout;
